import { render, staticRenderFns } from "./CrossCountryTimeComponent.vue?vue&type=template&id=5566fdca&scoped=true"
import script from "./CrossCountryTimeComponent.vue?vue&type=script&lang=ts"
export * from "./CrossCountryTimeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566fdca",
  null
  
)

export default component.exports